import { Button, Col, Modal, Row, Select, Spin, Switch, Table } from "antd";
import axios from "axios";
import React, { Component } from "react";

import { connect } from "react-redux";

import { PUSH_MED_AT_INDEX_OF } from "../../ActionTypes/ActionTypes";

const Option = { Select };
let timeout;
let currentValue;

function fetch(value, callback) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;

  function fake() {
    axios({
      method: "get",
      url: `/doctors/lookup_doctors.json?name=${value}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((d) => {
      let matchedList;
      if (currentValue === value) {
        matchedList = d.data;
      }
      callback(matchedList);
    });
  }

  timeout = setTimeout(fake, 300);
}

class DoctorMedLinkUpModal extends Component {
  state = {
    fetching: false,
    loading: false,
    docSearchValue: "",
    doctor_id: "",
    filtered: false,
    selectedRowKeys: [],
    docList: [],
    dummy: [],
  };

  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  handleSearch = (value) => {
    // console.log(value);
    this.setState({ fetching: true });
    if (value.length > 2) {
      fetch(value, (docList) =>
        this.setState({
          docList,
          fetching: false,
        })
      );
    }
  };

  handleChange = (value) => {
    this.setState({
      docSearchValue: value,
    });
  };

  handleMedSelect = (value) => {
    console.log(value);
    this.setState({ doctor_id: value });
  };

  doReset = () => {
    this.setState({ selectedRowKeys: [] });
    // this.onSelectChange([]);
  };

  makeMatch = () => {
    const { medicineList, pushMedAtIndexOf } = this.props;
    const { selectedRowKeys, doctor_id } = this.state;

    // console.log(medicineList[0].e_prescription_id);

    if (medicineList[0].e_prescription_id == null) {
      this.setState({ loading: true });
      // console.log('null');
      for (const id of selectedRowKeys) {
        const med = medicineList[id];
        med.doctor_id = doctor_id;
        pushMedAtIndexOf(id, med);
      }
      this.setState({ loading: false });
    } else {
      this.setState({ loading: true });
      for (const id of selectedRowKeys) {
        // console.log(id, doctor_id);
        axios({
          method: "put",
          url: `/prescription_medicines/${id}.json`,
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
          data: {
            prescription_medicine: {
              doctor_id,
            },
          },
        }).then((response) => {
          pushMedAtIndexOf(
            medicineList.indexOf(
              medicineList.filter((med) => med.id === id)[0]
            ),
            response.data
          );
        });
      }
      this.setState({ loading: false });
    }
    // console.log("hello");
    this.setState({
      docSearchValue: "",
      docList: [],
      selectedRowKeys: [],
    });
  };

  handleDisabledChange = () => {
    const { filtered } = this.state;
    this.setState({
      filtered: !filtered,
    });
  };

  render() {
    const { onCancel, visible, medicineList } = this.props;
    const {
      docList,
      dummy,
      docSearchValue,
      fetching,
      selectedRowKeys,
      loading,
      filtered,
    } = this.state;

    let showMedList;

    if (filtered) {
      showMedList = medicineList.filter((med) => med.doctor_id == null);
    } else {
      showMedList = medicineList;
    }

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };

    const columns = [
      medicineList[0].id == null
        ? {
            title: "IndexId",
            dataIndex: "index_id",
          }
        : {
            title: "Id",
            dataIndex: "id",
          },

      {
        title: "Name",
        dataIndex: "name",
      },
      {
        title: "Doctor",
        dataIndex: "doctor_id",
      },
    ];

    const docOptions =
      docList === undefined
        ? dummy.map((d) => <Option key={d.id}>{d.name}</Option>)
        : docList.map((d) => <Option key={d.id}>{d.name}</Option>);

    return (
      <Modal
        visible={visible}
        title="Medicines without doctor"
        style={{ top: 40, textAlign: "center" }}
        width="70%"
        onCancel={onCancel}
        footer={null}
      >
        <div>
          <h6>Filtered - </h6>

          <Switch
            size="default"
            checked={filtered}
            onChange={this.handleDisabledChange}
          />

          <br />
          <br />

          <Row type="flex" justify="space-between">
            <Col span={12}>
              <div style={{ textAlign: "center" }}>
                <Table
                  dataSource={showMedList}
                  rowSelection={rowSelection}
                  loading={loading}
                  columns={columns}
                  pagination={false}
                  scroll={{ y: 400 }}
                  rowKey="id"
                />
              </div>
            </Col>

            <Col span={10} style={{ borderLeft: "1px solid black" }}>
              <div style={{ paddingLeft: "2%", textAlign: "center" }}>
                <h6>Search for doctor</h6>
                <hr width="200px" />
                <br />

                <Select
                  showSearch
                  value={docSearchValue}
                  placeholder="Start typing Doctor name ..."
                  style={{ width: "80%" }}
                  defaultActiveFirstOption={false}
                  showArrow={false}
                  filterOption={false}
                  onSearch={this.handleSearch}
                  onChange={this.handleChange}
                  onSelect={this.handleMedSelect}
                  notFoundContent={fetching ? <Spin size="small" /> : null}
                >
                  {docOptions}
                </Select>

                <div style={{ textAlign: "center", marginTop: "10%" }}>
                  <Button type="primary" onClick={this.doReset}>
                    Reset
                  </Button>
                  <Button type="primary" onClick={this.makeMatch}>
                    Done
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  medicineList: state.AppState.medicineList,
});

const mapDispatchToProps = (dispatch) => ({
  pushMedAtIndexOf: (id, data) =>
    dispatch({ type: PUSH_MED_AT_INDEX_OF, payload: { id, data } }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DoctorMedLinkUpModal);



// WEBPACK FOOTER //
// ./src/component/AddingMedToOrder/DoctorMedLinkUpModal.js